const theme = {
  blue: 'rgb(20, 115, 230)',
  gray: 'rgb(112, 112, 112)',
};

export default theme;
